import React, { ReactElement } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import ChargeDetail from "./pages/charge/ChargeDetail";
import Receipt from "./pages/receipt";
import App from "./App";
import Test from "./pages/Test";
import Login from "./pages/login";
import LeaveBackground from "./pages/home/LeaveBackground";
import Org from "./pages/org";
import Merchant from "./pages/merchant";
import Charge from "./pages/charge";
import MyInfo from "./pages/myInfo";
import Withdraw from "./pages/withdraw";
import WithdrawReceipt from "./pages/withdraw/WithdrawReceipt";
import DirectPay from "./pages/directPay";
import Setting from "./pages/setting";
import EditAvatar from "./pages/myInfo/EditAvatar";
import CreateKyc from "./pages/verify/createKyc";
import SetOrgName from "./pages/myInfo/setOrg";
import VerifyInfo from "./pages/verify/verifyInfo";

const AppRoutes = (): ReactElement => {
  return (
    <Routes>
      <Route element={<App />}>
        <Route path="/" element={<Merchant />} />
        <Route path="/directPay" element={<DirectPay />} />
        <Route path="/myInfo" element={<MyInfo />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="/editAvatar" element={<EditAvatar />} />
        <Route path="/setOrgName" element={<SetOrgName />} />
        <Route path="/createKyc" element={<CreateKyc />} />
        <Route path="/verifyInfo" element={<VerifyInfo />} />

        {/* <Route
          path="/withdraw/complete/:txHash"
          element={<WithdrawComplete />}
        /> */}
        <Route
          path="/withdraw/receipt/:orderId"
          element={<WithdrawReceipt />}
        />
        <Route path="/setting" element={<Setting />} />
        <Route path="/org" element={<Org />} />
        <Route path="/charge" element={<Charge />} />
        <Route path="/test" element={<Test />} />
        <Route path="/leave-background" element={<LeaveBackground />} />
        <Route path="/login" element={<Login />} />
        {/* 收费相关路由 */}
        <Route path="/">
          <Route path="/charge/:orderId" element={<ChargeDetail />} />
        </Route>

        <Route path="/receipt/:orderId" element={<Receipt />} />

        {/* 404 路由重定向 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
